export const uploadConstants = {
  UPLOAD_FILE_SIZE_ERROR: 'UPLOAD_FILE_SIZE_ERROR',
  UPLOAD_FILE_TYPE_ERROR: 'UPLOAD_FILE_TYPE_ERROR',
  UPLOAD_FILE_ERROR: 'UPLOAD_FILE_ERROR',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_CLEAR_ERROR: 'UPLOAD_FILE_CLEAR_ERROR',
  DELETE_AVATAR_FILE_SUCCESS: 'DELETE_AVATAR_FILE_SUCCESS',
  DELETE_AVATAR_FILE_ERROR: 'DELETE_AVATAR_FILE_ERROR',
}
